import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import AdminNav from "../components/adminNav";
import Time from "../components/time";
import Swal from "sweetalert2";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const Vehicle_transfer_approval_list = () => {
  useAuthRedirect();
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);

  const canView  = hasPermission("Approval to Transfer", "view");
      const canEntry = hasPermission("Approval to Transfer", "entry");
      const canDel   = hasPermission("Approval to Transfer", "del");
    

  // Fetch data
  useEffect(() => {
    setLoading(true);
    axios.get("https://rfs2.infraconsoft.net.in/api/vehicle_transfer_to_appr_list")
      .then((response) => {
        setData(response.data.approvalList);
        setFilteredData(response.data.approvalList);
      })
      .catch((error) => {
        console.error("Error fetching approvalList:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  // Handle page change
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Calculate pagination indexes
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  // Handle search filter
  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    const filtered = data.filter((item) => {
      return (
        (item.fld_vehiclecode && item.fld_vehiclecode.toLowerCase().includes(e.target.value.toLowerCase())) ||
        (item.fld_transfer_from && item.fld_transfer_from.toLowerCase().includes(e.target.value.toLowerCase())) ||
        (item.fld_transfer_to && item.fld_transfer_to.toLowerCase().includes(e.target.value.toLowerCase()))
      );
    });
    setFilteredData(filtered);
    setCurrentPage(1); 
  };

  // Get userId from localStorage
const userId = localStorage.getItem("username");


const handleShiftUpdate = async (sno) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to update the shift?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          Swal.fire({
                            title: "Submitting...",
                            text: "Please wait while we process your request.",
                            allowOutsideClick: false,
                            didOpen: () => {
                              Swal.showLoading();
                            },
                          });

          const response = await axios.put("https://rfs2.infraconsoft.net.in/api/update_shift", { 
            sno, 
            user: userId 
          });
  
          if (response.data.success) {
            Swal.fire("Updated!", "Shift updated successfully.", "success");
  
            // Refresh the data after update
            setData((prevData) =>
              prevData.map((item) =>
                item.SlNo === sno ? { ...item, shift: "Updated Shift" } : item
              )
            );
            window.location.reload();
          } else {
            Swal.fire("Error", "Failed to update shift.", "error");
          }
        } catch (error) {
          console.error("Error updating shift:", error);
          Swal.fire("Error", "Something went wrong.", "error");
        }
      }
    });
  };
  
  const handleDelete = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!"
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
           Swal.fire({
                            title: "Submitting...",
                            text: "Please wait while we process your request.",
                            allowOutsideClick: false,
                            didOpen: () => {
                              Swal.showLoading();
                            },
                          });
          await axios.delete(`https://rfs2.infraconsoft.net.in/api/app_delete/${id}`);
          setData(data.filter((item) => item.SlNo !== id));
          setFilteredData(filteredData.filter((item) => item.SlNo !== id));

          Swal.fire({
            title: "Deleted!",
            text: "Your record has been deleted.",
            icon: "success"
          });
          window.location.reload();
        } catch (error) {
          console.error("Error deleting vehicle position:", error);
          Swal.fire({
            title: "Error!",
            text: "Failed to delete vehicle position.",
            icon: "error"
          });
        }
      }
    });
  };
 if (!canView) {
    return (
      <div id="admin-container">
        <AdminNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }

  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
          <h2 className="add-txt">Vehicle Transfer Approval List</h2>
          <div>
            <Time />
          </div>
        </section>

        {/* Search Filter */}
        <div className="search-filter">
          <p>Search: </p>
          <input
            type="text"
            placeholder="Search by Vehicle Code"
            value={searchTerm}
            onChange={handleSearch}
            className="search-input"
          />
        </div>

        <div className="content-table">
          <table>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Vehicle Code</th>
                <th>Transfer From</th>
                <th>Transfer To</th>
                <th>Transfer By</th>
                <th>Time</th>
                {canEntry && (
                <th>Shift</th>
                )}
                {canDel && (
                <th>Delete</th>
                )}
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="8" className="loading-text">Loading data, please wait...</td>
                </tr>
              ) : currentData.length > 0 ? (
                currentData.map((item, index) => (
                  <tr key={index}>
                    <td>{indexOfFirstItem + index + 1}</td>
                    <td>{item.fld_vehiclecode}</td>
                    <td>{item.fld_transfer_from}</td>
                    <td>{item.fld_transfer_to}</td>
                    <td>{item.fld_transfer_by}</td>
                    <td>{new Date(item.fld_transfer_time).toLocaleDateString()}</td>
                    {canEntry && (
                    <td>
  <button
    onClick={() => handleShiftUpdate(item.SlNo)}
    style={{
      backgroundColor: "#007bff",
      color: "#fff",
      border: "none",
      padding: "6px 12px",
      borderRadius: "5px",
      cursor: "pointer",
      fontSize: "14px",
      display: "flex",
      alignItems: "center",
      gap: "6px",
      boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
      transition: "background-color 0.3s ease"
    }}
    onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#0056b3")}
    onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#007bff")}
  >
    <i className="fas fa-random"></i> Shift
  </button>
</td>
                    )}
                    {canDel && (
                    <td className="del">
                      <i className="fa-solid fa-trash-can" onClick={() => handleDelete(item.SlNo)}></i>
                    </td>
                    )}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8">No Data Available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination Controls */}
        <div className="pagination">
          <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
            Previous
          </button>

          {/* Always show first page */}
          <button onClick={() => paginate(1)} className={currentPage === 1 ? 'active' : ''}>
            1
          </button>

          {/* Show up to 3 pages dynamically */}
          {filteredData.length > 0 &&
            [...Array(Math.min(3, Math.ceil(filteredData.length / itemsPerPage) - 1))].map((_, index) => {
              const pageNumber = currentPage + index;
              if (pageNumber > 1 && pageNumber <= Math.ceil(filteredData.length / itemsPerPage)) {
                return (
                  <button key={pageNumber} onClick={() => paginate(pageNumber)} className={currentPage === pageNumber ? 'active' : ''}>
                    {pageNumber}
                  </button>
                );
              }
              return null;
            })
          }

          {/* Next button */}
          <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === Math.ceil(filteredData.length / itemsPerPage)}>
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default Vehicle_transfer_approval_list;
